/* Footer: dieren kijken omhoog zodra de footer in beeld komt, en terug-naar-boven. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('lp-footer')) return;
  customElements.define('lp-footer', class extends HTMLElement {
    connectedCallback() {
      var foot = this.closest('.lpf');
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (foot && 'IntersectionObserver' in window && !calm) {
        var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { foot.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.15 });
        io.observe(foot);
      } else if (foot) foot.classList.add('is-in');
      var btn = this.querySelector('[data-lpf-top]');
      if (btn) btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' }); });
    }
  });
})();
